import { compose } from 'recompose';

import VariantCreate from './VariantCreate';

const enhance = compose();

export default enhance(VariantCreate);
